import Link from "@components/Theme/Link/Link"
import Typography, {
	Size,
	TypographyProps,
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {titleType} from "@customTypes/customTypes"
import {AdvancedSideAssetMainContent} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

export type ContentType = {
	size?: Size
	data?: AdvancedSideAssetMainContent
	titleType?: titleType
	shortDesc?: number
	without?: {
		upperTitle?: boolean
		title?: boolean
		subtitle?: boolean
		description?: boolean
	}
	onlyUpperTitle?: boolean
	onlyTitle?: boolean
	onlySubtitle?: boolean
	onlyDescription?: boolean
	asLink?: string
	asImagePopup?: boolean
	titleProps?: TypographyProps
	subtitleProps?: TypographyProps
	upperTitleProps?: TypographyProps
	contentProps?: TypographyProps
	maxWidth?: string
	containerClassName?: string
}

const Content = (props: ContentType) => {
	const content = (
		<div
			className={props.containerClassName}
			style={{
				maxWidth: props.maxWidth || "100%",
				margin: props.maxWidth ? "0 auto" : "0",
			}}
		>
			{!props.without?.upperTitle && (
				<Typography
					content={props.data?.upperTitle}
					stripHtml={false}
					size={Size.S}
					as={"h6"}
					fontWeight={400}
					variant={Variant.Title}
					{...props.upperTitleProps}
				/>
			)}
			{!props.without?.title && (
				<Typography
					content={props.data?.title}
					fontWeight={600}
					noPadding={
						!props.without?.description &&
						props.data?.content &&
						!props.without?.subtitle &&
						!props.data?.subtitle
							? true
							: undefined
					}
					size={Size.XL}
					stripHtml={false}
					variant={Variant.Title}
					{...props.titleProps}
				/>
			)}
			{!props.without?.subtitle && (
				<Typography
					content={props.data?.subtitle}
					stripHtml={false}
					variant={Variant.Paragraph}
					{...props.subtitleProps}
				/>
			)}
			{!props.without?.description && (
				<Typography
					content={props.data?.content}
					size={Size.XS}
					stripHtml={false}
					truncate={props.shortDesc}
					variant={Variant.Description}
					noPadding
					{...props.contentProps}
				/>
			)}
		</div>
	)

	return (
		<>
			{props.asLink && <Link link={props.asLink ?? "/#"}>{content}</Link>}
			{props.asImagePopup && (
				<Link link={props.asLink ?? "/#"}>{content}</Link>
			)}
			{!props.asLink && <>{content}</>}
		</>
	)
}

export default Content
